import React, { useMemo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  forms,
  allRequiredEscalationForm,
} from 'constants/clinicalEscalationForm';
import MasterModal from 'components/organisms/masterModal';
import { useRunbookLog } from 'infrastructure/hooks/clinic/use-runbook-logs';
import Section from 'components/molecules/section';
import BaseButton from 'components/atoms/baseButton';

const ClinicEscalationFormModal = ({
  isOpen,
  closeModal,
  onSubmit,
  clinicGuid,
  defaultValue = {},
  submitLoading,
}) => {
  const { runbookLogs, loading } = useRunbookLog({
    meta: {
      clinicGuid,
      items: 1,
    },
  });

  const [modalValue, setModalValue] = useState(defaultValue);
  const setValue = (value) => {
    setModalValue((prev) => ({ ...prev, ...value }));
  };

  useEffect(() => {
    if (runbookLogs?.items?.length > 0) {
      const contactMethod = runbookLogs?.items[0]?.contactMethod;
      const phoneOrEmailOfPersonYouAreCalling =
        runbookLogs?.items[0]?.contactMethodValue;
      const patientContactMethod = runbookLogs?.items[0]?.contactMethod;
      const contactMethodValue = runbookLogs?.items[0]?.contactMethodValue;
      const criticalBusinessHours =
        runbookLogs?.items[0]?.criticalBusinessHours;
      const criticalAfterHours = runbookLogs?.items[0]?.criticalAfterHours;
      const afterHours = runbookLogs?.items[0]?.afterHours;
      const businessHours = runbookLogs?.items[0]?.businessHours;
      const notes = runbookLogs?.items[0]?.notes;
      const dateNoteLogged = runbookLogs?.items[0]?.dateNoteLogged;
      setModalValue({
        ...defaultValue,
        contactMethod,
        phoneOrEmailOfPersonYouAreCalling,
        patientContactMethod,
        contactMethodValue,
        criticalBusinessHours,
        criticalAfterHours,
        afterHours,
        businessHours,
        notes,
        dateNoteLogged,
      });
    }
  }, [runbookLogs?.items]);

  const disableSaveButton = useMemo(
    () =>
      allRequiredEscalationForm.some((formId) => {
        const value = modalValue[formId];
        if (Array.isArray(value) && !value.length) {
          return true;
        }
        if (!value) {
          return true;
        }
        return false;
      }),
    [modalValue],
  );

  const submit = () => {
    const values = {};
    Object.keys(modalValue).forEach((key) => {
      if (Array.isArray(modalValue[key])) {
        values[key] = modalValue[key].map((item) => item.value);
      } else {
        values[key] = modalValue[key];
      }
    });

    onSubmit(values);
  };

  return (
    <MasterModal
      isOpen={isOpen}
      toggle={closeModal}
      title="Clinical Escalation"
      size="medium"
      footer={
        <BaseButton
          onClick={submit}
          disabled={disableSaveButton || submitLoading || loading}
          label={submitLoading ? 'Saving...' : 'Save'}
        />
      }
    >
      <div className="narrative-popup">
        <div className="input-wrapper">
          <span>
            This form is used for all clinics with the exception of WATSON
            escalations must go through the Care Link application found in the
            run book.
          </span>
        </div>
        <Section forms={forms} setValue={setValue} values={modalValue} />
      </div>
    </MasterModal>
  );
};

ClinicEscalationFormModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  onSubmit: PropTypes.func,
  defaultValue: PropTypes.object,
  clinicGuid: PropTypes.string,
  submitLoading: PropTypes.bool,
};

export default ClinicEscalationFormModal;
